import { render, staticRenderFns } from "./sidebar-discount-codes.vue?vue&type=template&id=0ebe9a44&scoped=true"
import script from "./sidebar-discount-codes.vue?vue&type=script&lang=js"
export * from "./sidebar-discount-codes.vue?vue&type=script&lang=js"
import style0 from "./sidebar-discount-codes.vue?vue&type=style&index=0&id=0ebe9a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebe9a44",
  null
  
)

export default component.exports